// extracted by mini-css-extract-plugin
export default {"container":"CommonButton_container__0orNV","isDisabled":"CommonButton_isDisabled__uLaRG","loading":"CommonButton_loading__QJGw9","dot":"CommonButton_dot__pW8f7"};